import { API_NOTIFICATIONS_URL } from '../../constants/env';
import { EMITTER_EVENTS } from '../../constants/main';
import { addNotification } from './notificationsActions';
import { TEMP_STORAGE_KEYS } from '../../constants/main';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { notificationsActions } from './notificationsSlice';
import EventEmitter from 'eventemitter3';

let eventSource = null;
export const notificationEmitter = new EventEmitter();

export const establishPushNotifications = (userId, organizationId) => (dispatch) => {
  dispatch(notificationsActions.establishConnectionStart());

  const token = localStorage.getItem(TEMP_STORAGE_KEYS.TOKEN);
  const headers = { authorization: `Bearer ${token}` };

  eventSource = new EventSourcePolyfill(`${API_NOTIFICATIONS_URL}organizations/${organizationId}/notifications/events?userId=${userId}`, { headers });

  eventSource.onopen = () => {
    dispatch(notificationsActions.establishConnectionSuccess());
  };

  eventSource.onmessage = function(event) {
    const parsedJson = JSON.parse(event.data);
    addNotification(parsedJson.data);
    notificationEmitter.emit(EMITTER_EVENTS.NEW_NOTIFICATION, parsedJson.data);
  };

  eventSource.onerror = function(error) {
    dispatch(notificationsActions.establishConnectionFail());
  };
};

export const disconnectPushNotifications = () => (dispatch) => {
  if (eventSource) {
    eventSource.close();
    eventSource = null;
    console.log('Disconnected from push notifications');
  }
  dispatch(notificationsActions.disconnect());
};
